/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

function route (path, view, name, meta, children = null) {
  let data = {
    name: name || view,
    path,
    meta,
    component: (resovle) => import(
      `@/views/${view}.vue`
    ).then(resovle)
  }

  if (children) {
    data.children = routes(children)
  }

  return data
}

function routes (paths) {
  return paths.map(path => route(path.path, path.view, path.name, path.meta, path.children))
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: routes(paths).concat([
    { path: '*', redirect: '/' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach(function (to, from, next) {
  // prevent access to login & register once signed in...
  if (to.matched.some(record => record.meta.requiresGuest) &&
        Vue.prototype.$auth.isAuthenticated()) {
    next({ path: '/dashboard' })
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // routes with meta.requiresAuth attr require user to be authorized
    // if not, redirect to /auth/signin...
    if (!window.auth.isAuthenticated()) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    }
  }

  next() // make sure to always call next()!
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
